import axios from "axios";
import { Language } from "../models";

export const getLanguages = () => {
    return axios.get<Language[]>(`Languages`);
}

export const redirectToLanguageHome = (
    langCode: string
): void => {
    localStorage.setItem("lang", langCode);
    window.location.href = `/${langCode}`;
};